import moment from "moment";

export const mapingDate = (date_start: string, date_end: string) => {
    const start = moment(date_start);
    const end = moment(date_end);

    const dates: string[] = [];

    while (start <= end) {
        dates.push(start.format("YYYY-MM-DD"));
        start.add(1, "day");
    }

    return dates;
};